import React, {useState, useContext} from 'react';
import './UserForm.scss';
import {I18nContext} from '../../contexts/i18nContext';
import {AdminContext} from '../../contexts/adminContext';
import {Button, SelectInput, TextInput} from '../_common';
const UserForm = (
  {user, updateUserData, rolesOptions, primaryButtonAction, secondaryButtonAction, emailError, setEmailError}
) => {
  const { t } = useContext(I18nContext);
  const {
    addUserPending,
    error,
  } = useContext(AdminContext);

  const [formValues, setFormValues] = useState({
    firstName: user?.firstName ?? '',
    lastName: user?.lastName ?? '',
    email: user?.email ?? '',
    role: user ? rolesOptions.find(x => x.id === user.role).id : rolesOptions[1].id,
    password: ''
  });
  const [passwordStrengthError, setPasswordStrengthError] = useState(false);

  const changeValue = (name, value) => {
    if (name === "password") {
      setPasswordStrengthError(false);
    }
    if (name === "email") {
      setEmailError(false);
    }
    const newValues = {...formValues};
    newValues[name] = value;
    setFormValues(newValues);
    updateUserData(newValues);
  };

  const formHasEmptyFields = () => {
    const emptyOptionInputs = Object.values(formValues).filter(item => !item);
    return !user ? !!emptyOptionInputs.length : emptyOptionInputs.length > 1;
  };

  const checkPasswordStrength = (password) => {
    const regex = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
    return regex.test(password);
  };

  const handleAddUserClick = () => {
    if (!!user || checkPasswordStrength(formValues.password)) {
      primaryButtonAction(formValues);
    } else {
      setPasswordStrengthError(true);
    }
  };

  return (
    <form className='UserForm'>
      <div className='formInputs'>
        <SelectInput
          name='role'
          label={t('role')}
          options={rolesOptions}
          onSelect={changeValue}
          value={formValues.role}
          placeholder={t('select')}
          required
        />
        <TextInput
          label={t('e-mail address')}
          required
          name='email'
          placeholder={t('enter e-mail address')}
          onChange={changeValue}
          value={formValues.email}
          disabled={!!user}
          type='email'
        />
        {emailError && (
          <div className='errorMessage'>
            {t('user with this e-mail address already exists')}.
          </div>
        )}
        {!user && (
          <TextInput
            label={t('password')}
            required
            name='password'
            placeholder={t('enter password')}
            onChange={changeValue}
            value={formValues.password}
            type={'password'}
          />
        )}
        {!passwordStrengthError && !user && (
          <div className='passwordMessage'>
            {t('the password should consist of a least 8 characters, 1 capital letter, 1 number and 1 special character')}
          </div>
        )}
        {passwordStrengthError && (
          <div className='errorMessage'>
            {t('the password should consist of a least 8 characters, 1 capital letter, 1 number and 1 special character')}.
          </div>
        )}
        <TextInput
          label={t('first name')}
          required
          name='firstName'
          placeholder={t('enter first name')}
          onChange={changeValue}
          value={formValues.firstName}
        />
        <TextInput
          label={t('last name')}
          required
          name='lastName'
          placeholder={t('enter last name')}
          onChange={changeValue}
          value={formValues.lastName}
        />
      </div>
      <div className='formButtons'>
        <Button type='secondary' action={secondaryButtonAction} label={t('cancel')} />
        <Button
          type='primary'
          action={handleAddUserClick}
          label={!user ? t('add user'): t('edit user')}
          margin='left'
          disabled={addUserPending || formHasEmptyFields()}
          pending={addUserPending}
        />
      </div>
    </form>
  );
};

export default UserForm;
